import React, { useEffect, useState } from "react";
import * as firebase from "firebase";
import { Layout, Row, Col, Typography, message, Modal, Card } from "antd";
import DeckForm from "../Components/DeckForm";
import DeckTable from "../Components/DeckTable";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import {
  getDeck,
  deleteFileFromStorage,
  deleteDeck,
  addArticle,
  addLatestArticle,
  addFeaturedId,
  updateArticleFieldsWithImage,
  updateArticleFields,
  getLiveStream,
  setLiveStream,
  getArticleSliders,
  updateArticleSliders,
  updateNewsSliders,
  getAuthors,
  addAuthor,
  getFeaturedId,
  deleteAuthor,
  getAppUsers,
  getNewsSliders,
  deleteCommentRecord,
  signupUser,
} from "../Database/firebase";
import { storage } from "firebase";
import { v4 as uuidv4 } from "uuid";
import { Redirect } from "react-router-dom";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import CommentsTable from "../Components/CommentsTable";
// import data from "../dummydata";
import moment from "moment-timezone";
import { isEmpty, map, filter, includes } from "lodash";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import LiveStream from "../Components/LiveStream";

const { Content } = Layout;
const { confirm } = Modal;

export default function HomePage({ history }) {
  const [user, setUser] = useState(null);
  const [decks, setDecks] = useState([]);
  const [imageAsFile, setImageAsFile] = useState(null);
  const [videoAsFile, setVideoAsFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [loggedIn, setLoggedIn] = useState(null);
  const [visible, setVisible] = useState(false);
  const [featuredId, setFeaturedId] = useState([]);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [breakingNews, setBreakingNews] = useState(false);
  const [featured, setFeatured] = useState(false);
  const [none, setNoneStatus] = useState(false);
  const [applyedFilters, setApplyedFilters] = useState([]);

  const [descriptionEditor, setDescriptionEditor] = useState(
    EditorState.createWithContent(
      ContentState.createFromBlockArray(convertFromHTML(``))
    )
  );

  const [date, setDate] = useState(null);
  const [timer, setTimer] = useState(null);
  const [zone, setZone] = useState("America/New_York");

  const [tags, setTags] = useState("");
  const [affiliateLink, setAffiliateLink] = useState("");
  const [releaseNewsPrice, setreleaseNewsPrice] = useState("");

  const [releaseDetailWhen, setreleaseDetailWhen] = useState("");
  const [releaseDetailwhere, setreleaseDetailwhere] = useState("");
  const [releaseDetailPrice, setreleaseDetailPrice] = useState("");

  const [liveStreamUrl, setLiveStreamUrl] = useState("");
  const [liveStreamTitle, setliveStreamTitle] = useState("");
  const [isLiveStream, setIsLiveStream] = useState(false);
  const [streamLoading, setStreamLoading] = useState(false);
  const [articleSliders, setArticleSliders] = useState([]);
  const [newsSliders, setNewsSliders] = useState([]);

  const [authors, setAuthors] = useState(null);
  const [authorName, setAuthorName] = useState("");
  const [authorEmail, setAuthorEmail] = useState("");
  const [authorPassword, setAuthorPassword] = useState("");

  const [notificationTitle, setNotificationTitle] = useState("");
  const [notificationMessage, setNotificationMessage] = useState("");
  const [tokens, setTokens] = useState("");
  const [tokenLoading, setTokenLoading] = useState(true);
  const [comments, setComments] = useState([]);
  const [toogleCoomentModal, setToogleCoomentModal] = useState(false);

  const [selectedArticle, setSelectedArticle] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [imagePath, setImagePath] = useState(null);
  const [videoPath, setVideoPath] = useState(null);
  const [imageName, setImageName] = useState("");
  const [videoName, setVideoName] = useState("");
  const [isShowCommentSection, setIsShowCommentSection] = useState(false);
  const [isNewSliderArticle, setisNewSliderArticle] = useState(false);
  const [isBreakingNews, setisBreakingNews] = useState(false);
  const [webViewCommentLink, setWebViewCommentLink] = useState(null);

  useEffect(() => {
    localStorage.setItem("descriptionImagesUrl", JSON.stringify([]));
    // addFeaturedId([], false, false);
    setStreamLoading(true);
    getFeaturedId.then((doc) => {
      // console.log("on use effect???", doc.data().FeaturedId);
      console.log(doc.data())
      setFeaturedId(doc.data().FeaturedId);
      setBreakingNews(doc.data().news);
      setFeatured(doc.data().featured);
    }).catch(error => {
      console.log(error)
    })

    let user = localStorage.getItem("User");
    if (user) {
      //setLoggedIn(true);
      setLoggedIn(false);
      alert("Out of memory");
      return
      setUser(JSON.parse(user));
      // console.log("user is", JSON.parse(user));
    } else {
      setLoggedIn(false);
    }

    getDeck
      .then((snap) => {
        let temp = [];
        if (!isEmpty(snap)) {
          snap.forEach((doc) => {
            temp.push({ ...{ id: doc.id }, ...doc.data() });
          });
          // console.log("print",snap)
          setDecks(temp);
        }
      })
      .catch((error) => {
        setLoggedIn(false);
        localStorage.clear();
      });

    getLiveStream.then((doc) => {
      setStreamLoading(false);
      setIsLiveStream(doc.data().isLiveStream);
      setLiveStreamUrl(doc.data().videoUrl);
      setliveStreamTitle(doc.data().title);
    });

    getArticleSliders.then((doc) => {
      setArticleSliders(doc.data().sliders);
    });

    getNewsSliders.then((doc) => {
      setNewsSliders(doc.data().sliders);
    });

    getAuthors.then((snap) => {
      let temp = [];
      snap.forEach((doc) => {
        temp.push({ ...{ id: doc.id }, ...doc.data() });
      });
      setAuthors(temp);
    });

    getAppUsers.then((snap) => {
      let temp = [];
      snap.forEach((doc) => {
        if (doc.data().token !== undefined) temp.push(doc.data().token);
      });
      setTokens(temp);
      setTokenLoading(false);
    });
  }, []);

  const uploadTaskDeckUpdate = (
    refName,
    imageOrVideoName,
    updatedTags,
    imageOrVideoFile
  ) => {
    updateDescriptionImages().then(() => {
      const uploadTask = storage()
        // .ref(`/article_images/${imageName}`)
        .ref(`/${refName}/${imageOrVideoName}`)
        .put(imageOrVideoFile.originFileObj);
      uploadTask.on(
        "state_changed",
        (snapShot) => {
          console.log(snapShot);
        },
        (err) => {
          console.log(err);
        },
        () => {
          storage()
            .ref(refName)
            .child(imageOrVideoName)
            .getDownloadURL()
            .then((fireBaseUrl) => {
              const article = {
                title,
                description,
                description_editor: draftToHtml(
                  convertToRaw(descriptionEditor.getCurrentContent())
                ),
                tags: updatedTags,
                // breakingNews:breakingNews,
                applyedFilters: applyedFilters,
                date,
                timer: timer ? timer : null,
                zone: zone,
                imageUrl: refName === "article_images" ? fireBaseUrl : imageUrl,
                videoUrl: refName === "article_videos" ? fireBaseUrl : videoUrl,
                imagePath:
                  refName === "article_images"
                    ? `/${refName}/${imageOrVideoName}`
                    : imagePath,
                videoPath:
                  refName === "article_videos"
                    ? `/${refName}/${imageOrVideoName}`
                    : videoPath,
                affiliateLink: affiliateLink,
                releaseNewsPrice: releaseNewsPrice,
                releaseDetailWhen: releaseDetailWhen,
                releaseDetailwhere:releaseDetailwhere,
                releaseDetailPrice:releaseDetailPrice,
                news: timer === null ? false : true,
                authorIs: user.authorName ? user.authorName : "",
                descriptionImages: JSON.parse(
                  localStorage.getItem("descriptionImagesUrl")
                ),
                isShowCommentSection,
                webViewCommentLink:  isShowCommentSection ? webViewCommentLink : null,
                isNewSliderArticle,
                isBreakingNews
              };

              updateArticleFieldsWithImage(selectedCard.id, article).then(
                () => {
                  //console.log("featuredId == selectedCard.id && !featuredId3",featuredId, selectedCard.id ,!featuredId,featuredId == selectedCard.id && !featuredId)
                  //console.log("applyedFilters>>>",applyedFilters);
                  //to set none from featured or breaking news
                  if (
                    includes(featuredId, selectedCard.id)  &&
                    !featured &&
                    !breakingNews
                  ) {
                    addFeaturedId(filter(featuredId, fID => fID !== selectedCard.id), featured, breakingNews);
                    setFeaturedId(filter(featuredId, fID => fID !== selectedCard.id));
                  }
                  //to set featured or breaking
                  else if (featured || breakingNews) {
                    if (
                      includes(featuredId, selectedCard.id) ||
                      (isEmpty(featuredId) && !none)
                    ) {
                      addFeaturedId([...featuredId, selectedCard.id], featured, breakingNews);
                      setFeaturedId([...featuredId, selectedCard.id])
                    }
                  }

                  const temp = [...decks];
                  const index = temp.findIndex(
                    (el) => el.id === selectedCard.id
                  );
                  temp[index].title = title;
                  temp[index].description = description;
                  temp[index].description_editor = draftToHtml(
                    convertToRaw(descriptionEditor.getCurrentContent())
                  );
                  temp[index].tags = updatedTags;
                  //  temp[index].breakingNews=breakingNews;
                  temp[index].applyedFilters = applyedFilters;
                  temp[index].date = date;
                  temp[index].timer = timer ? timer : null;
                  temp[index].imageUrl =
                    refName === "article_images" ? fireBaseUrl : imageUrl;
                  temp[index].videoUrl =
                    refName === "article_videos" ? fireBaseUrl : videoUrl;
                  // temp[index].imagePath = `/article_images/${imageName}`;
                  temp[index].imagePath =
                    refName === "article_images"
                      ? `/${refName}/${imageOrVideoName}`
                      : imagePath;
                  temp[index].videoPath =
                    refName === "article_videos"
                      ? `/${refName}/${imageOrVideoName}`
                      : videoPath;
                  temp[index].affiliateLink = affiliateLink;
                  temp[index].releaseNewsPrice = releaseNewsPrice;
                  temp[index].releaseDetailWhen = releaseDetailWhen;
                  temp[index].releaseDetailwhere  = releaseDetailwhere;
                  temp[index].releaseDetailPrice = releaseDetailPrice;
                  temp[index].news = timer === null ? false : true;
                  temp[index].authorIs = user.authorName ? user.authorName : "";
                  temp[index].descriptionImages = JSON.parse(
                    localStorage.getItem("descriptionImagesUrl")
                  );

                  setDecks(temp);
                  setLoading(false);
                  resetFields();
                  resetDescriptionImagesFromLocalStorage();
                  message.info("Article Updated!");
                }
              );
            })
            .catch((err) => {
              console.log("ERR updateDeckNameImage", err.message);
            });
        }
      );
    });
  };

  const deleteImagesFileFromStorage = (
    refName,
    file,
    imageOrVideoName,
    updatedTags
  ) => {
    const path =
      refName === "article_images"
        ? selectedCard.imagePath
        : selectedCard.videoPath;
    deleteFileFromStorage(path).then(() => {
      uploadTaskDeckUpdate(refName, imageOrVideoName, updatedTags, file);
    });
  };

  const updateDeckArticleWithImageOrVideo = (
    refName,
    updatedTags,
    fireBaseUrl
  ) => {
    updateDescriptionImages().then(() => {
      const article = {
        title,
        description,
        description_editor: draftToHtml(
          convertToRaw(descriptionEditor.getCurrentContent())
        ),
        tags: updatedTags,
        // breakingNews:breakingNews,
        applyedFilters: applyedFilters,
        date,
        timer: timer ? timer : null,
        imageUrl:
          refName === "article_images"
            ? fireBaseUrl
            : imageUrl
            ? imageUrl
            : localStorage.getItem("uploadedImageUrl"),
        vidioUrl:
          refName === "article_videos"
            ? fireBaseUrl
            : videoUrl
            ? videoUrl
            : localStorage.getItem("uploadedVideoUrl"),
        zone,
        imagePath:
          refName === "article_images"
            ? `/article_images/${refName}`
            : imagePath
            ? imagePath
            : localStorage.getItem("imagePath"),
        videoPath:
          refName === "article_videos"
            ? `/article_videos/${refName}`
            : videoPath
            ? videoPath
            : localStorage.getItem("videoPath"),
        affiliateLink: affiliateLink,
        releaseNewsPrice: releaseNewsPrice,
        releaseDetailWhen: releaseDetailWhen,
        releaseDetailwhere: releaseDetailwhere,
        releaseDetailPrice: releaseDetailPrice,
        news: timer === null ? false : true,
        authorIs: user.authorName ? user.authorName : "",
        descriptionImages: JSON.parse(
          localStorage.getItem("descriptionImagesUrl")
        ),
        isShowCommentSection,
        webViewCommentLink: isShowCommentSection ? webViewCommentLink : null,
        isNewSliderArticle,
        isBreakingNews
      };

      updateArticleFieldsWithImage(selectedCard.id, article).then(() => {
        // getFeaturedId.then((doc) => {
        //   setFeaturedId(doc.data().FeaturedId);
        // });
        //console.log("featuredId == selectedCard.id && !featuredId1",featuredId, selectedCard.id ,!featuredId,featuredId == selectedCard.id && !featuredId)
        //to set none from featured or breaking news
        if (includes(featuredId, selectedCard.id) && !featured && !breakingNews) {
          addFeaturedId(filter(featuredId, fID => fID !== selectedCard.id), featured, breakingNews);
          setFeaturedId(filter(featuredId, fID => fID !== selectedCard.id));
        }
        //to set featured or breaking
        else if (featured || breakingNews) {
          if (includes(featuredId, selectedCard.id) || (featuredId === [] && !none)) {
            addFeaturedId([...featuredId, selectedCard.id], featured, breakingNews);
            setFeaturedId([...featuredId, selectedCard.id]);
          }
        }

        const temp = [...decks];
        const index = temp.findIndex((el) => el.id === selectedCard.id);
        temp[index].title = title;
        temp[index].description = description;
        temp[index].description_editor = draftToHtml(
          convertToRaw(descriptionEditor.getCurrentContent())
        );
        temp[index].tags = updatedTags;
        temp[index].applyedFilters = applyedFilters;
        temp[index].date = date;
        temp[index].timer = timer ? timer : null;
        temp[index].imageUrl =
          refName === "article_images"
            ? fireBaseUrl
            : imageUrl
            ? imageUrl
            : localStorage.getItem("uploadedImageUrl");
        temp[index].videoUrl =
          refName === "article_videos"
            ? fireBaseUrl
            : videoUrl
            ? videoUrl
            : localStorage.getItem("uploadedVideoUrl");
        temp[index].imagePath =
          refName === "article_images"
            ? `/article_images/${imageName}`
            : imagePath
            ? imagePath
            : localStorage.getItem("imagePath");
        temp[index].videoPath =
          refName === "article_videos"
            ? `/article_videos/${videoName}`
            : videoPath
            ? videoPath
            : localStorage.getItem("videoPath");
        temp[index].news = timer === null ? false : true;
        temp[index].affiliateLink = affiliateLink;
        temp[index].releaseNewsPrice = releaseNewsPrice;
        temp[index].releaseDetailWhen = releaseDetailWhen;
        temp[index].releaseDetailwhere = releaseDetailwhere;
        temp[index].releaseDetailPrice = releaseDetailPrice;
        temp[index].authorIs = user.authorName ? user.authorName : "";
        temp[index].descriptionImages = JSON.parse(
          localStorage.getItem("descriptionImagesUrl")
        );

        setDecks(temp);
        setLoading(false);
        message.info("Article Updated!");
        resetDescriptionImagesFromLocalStorage();
      });
    });
  };

  const updateDeckWithImagesOrVideos = (
    refName,
    imageOrVideoName,
    updatedTags,
    imageOrVideoFile
  ) => {
    // console.log("Deleted Old File");
    return new Promise((resolutionFunc, rejectionFunc) => {
      const uploadTask = storage()
        .ref(`/${imageOrVideoName}/${refName}`)
        .put(imageOrVideoFile.originFileObj);
      uploadTask.on(
        "state_changed",
        (snapShot) => {
          console.log(snapShot);
        },
        (err) => {
          console.log(err);
        },
        () => {
          storage()
            .ref(imageOrVideoName)
            .child(refName)
            .getDownloadURL()
            .then(async (fireBaseUrl) => {
              !(imageAsFile && videoAsFile) &&
                updateDeckArticleWithImageOrVideo(
                  refName,
                  updatedTags,
                  fireBaseUrl
                );
              // const afterUrlUpdate = await
              if (refName === "article_images") {
                setImageUrl(fireBaseUrl);
                setImagePath(`/article_images/${imageOrVideoName}`);
                setImageName(imageOrVideoName);
                localStorage.setItem("uploadedImageUrl", fireBaseUrl);
                localStorage.setItem(
                  "imagePath",
                  `/article_images/${imageOrVideoName}`
                );
              } else {
                setVideoUrl(fireBaseUrl);
                setVideoPath(`/article_videos/${imageOrVideoName}`);
                setVideoName(imageOrVideoName);

                localStorage.setItem("uploadedVideoUrl", fireBaseUrl);
                localStorage.setItem(
                  "videoPath",
                  `/article_videos/${imageOrVideoName}`
                );

                if (
                  !isEmpty(imageAsFile) &&
                  !isEmpty(videoAsFile) &&
                  !isEmpty(localStorage.getItem("uploadedImageUrl"))
                ) {
                  updateDeckArticleWithImageOrVideo(null, updatedTags, null);
                }
              }
              resolutionFunc(true);
            })
            .catch((err) => {
              console.log("ERR updateDeckNameImage", err.message);
            });
        }
      );
    });
  };
  const updateDescriptionImages = () => {
    return new Promise((resolutionFunc) => {
      const imgUrls = [];
      const entityMap = convertToRaw(descriptionEditor.getCurrentContent())
        .entityMap;
      map(filter(entityMap, { type: "IMAGE" }), (entity) => {
        imgUrls.push(entity.data.src);
      });
      localStorage.setItem("descriptionImagesUrl", JSON.stringify(imgUrls));
      resolutionFunc(true);
    });
  };

  const resetDescriptionImagesFromLocalStorage = () => {
    localStorage.setItem("descriptionImagesUrl", JSON.stringify([]));
  };

  const updateDeckWithoutImagesOrVideos = (updatedTags) => {
    console.log("here is is updateDeckWithoutImagesOrVideos func", isNewSliderArticle)
    updateDescriptionImages().then(() => {
      const article = {
        title,
        description,
        description_editor: draftToHtml(
          convertToRaw(descriptionEditor.getCurrentContent())
        ),
        applyedFilters: applyedFilters,
        tags: updatedTags,
        date,
        zone,
        timer: timer ? timer : null,
        news: timer === null ? false : true,
        affiliateLink: affiliateLink,
        releaseNewsPrice: releaseNewsPrice,
        releaseDetailWhen: releaseDetailWhen,
        releaseDetailwhere:releaseDetailwhere,
        releaseDetailPrice:releaseDetailPrice,
        authorIs: user.authorName ? user.authorName : "",
        descriptionImages: JSON.parse(
          localStorage.getItem("descriptionImagesUrl")
        ),
        isShowCommentSection,
        webViewCommentLink: isShowCommentSection ? webViewCommentLink : null,
        isNewSliderArticle,
        isBreakingNews
      };

      updateArticleFields(selectedCard.id, article)
        .then(() => {
          //to set none from featured or breaking news
          if (includes(featuredId, selectedCard.id) && !featured && !breakingNews) {
            addFeaturedId(filter(featuredId,  fID => fID !== selectedCard.id), featured, breakingNews);
            setFeaturedId(filter(featuredId,  fID => fID !== selectedCard.id));
          }
          //to set featured or breaking
          else if (featured || breakingNews) {
            if (
              (!includes(featuredId, selectedCard.id) && !none)
            ) {
              addFeaturedId([...featuredId, selectedCard.id], featured, breakingNews);
              setFeaturedId([...featuredId, selectedCard.id]);
            }
          }

          const temp = [...decks];
          const index = temp.findIndex((el) => el.id === selectedCard.id);
          temp[index].title = title;
          temp[index].description = description;
          temp[index].description_editor = draftToHtml(
            convertToRaw(descriptionEditor.getCurrentContent())
          );
          temp[index].tags = updatedTags;
          temp[index].applyedFilters = applyedFilters;
          temp[index].date = date;
          temp[index].timer = timer ? timer : null;
          temp[index].affiliateLink = affiliateLink;
          temp[index].releaseNewsPrice =releaseNewsPrice;
          temp[index].releaseDetailWhen = releaseDetailWhen;
          temp[index].releaseDetailwhere  = releaseDetailwhere;
          temp[index].releaseDetailPrice = releaseDetailPrice;
          temp[index].authorIs = user.authorName ? user.authorName : "";
          temp[index].descriptionImages = JSON.parse(
            localStorage.getItem("descriptionImagesUrl")
          );

          setDecks(temp);
          setLoading(false);
          setImageAsFile(null);
          cancelEditMode()
          message.info("Article Updated!");
          resetDescriptionImagesFromLocalStorage();
        })
        .catch((err) => {
          console.log("ERR updateDeckName", err.message);
        });
    });
  };

  const updateDeck = (e) => {
    console.log("when clicked on updated>>>>>")
    e.preventDefault();
    const imageName = uuidv4();
    const videoName = uuidv4();

    // console.log("start of update deck 11");
    // if (imageAsFile === "") {
    //   return console.error(
    //     `not an image, the image file is a ${typeof imageAsFile}`
    //   );
    // }
    let updatedTags = tags;
    if (typeof tags === "string") updatedTags = tags.split(",");

    setLoading(true);
    if (imageAsFile && videoAsFile) {
      updateDeckWithImagesOrVideos(
        "article_images",
        imageName,
        updatedTags,
        imageAsFile
      ).then(() => {
        updateDeckWithImagesOrVideos(
          "article_videos",
          imageName,
          updatedTags,
          videoAsFile
        );
      });
    } else if (imageAsFile) {
      if (selectedCard.imageUrl) {
        deleteImagesFileFromStorage(
          "article_images",
          imageAsFile,
          imageName,
          updatedTags
        );
      } else {
        updateDeckWithImagesOrVideos(
          "article_images",
          imageName,
          updatedTags,
          imageAsFile
        );
      }
    } else if (videoAsFile) {
      if (selectedCard.videoUrl) {
        deleteImagesFileFromStorage(
          "article_videos",
          videoAsFile,
          videoName,
          updatedTags
        );
      } else {
        updateDeckWithImagesOrVideos(
          "article_videos",
          imageName,
          updatedTags,
          videoAsFile
        );
        // console.log("Deleted Old File");
        // const uploadTask = storage()
        //   .ref(`/article_images/${imageName}`)
        //   .put(imageAsFile.originFileObj);
        // uploadTask.on(
        //   "state_changed",
        //   (snapShot) => {
        //     console.log(snapShot);
        //   },
        //   (err) => {
        //     console.log(err);
        //   },
        //   () => {
        //     storage()
        //       .ref("article_images")
        //       .child(imageName)
        //       .getDownloadURL()
        //       .then((fireBaseUrl) => {
        //         const article = {
        //           title,
        //           description,
        //           description_editor: draftToHtml(
        //             convertToRaw(descriptionEditor.getCurrentContent())
        //           ),
        //           tags: updatedTags,
        //           // breakingNews:breakingNews,
        //           applyedFilters: applyedFilters,
        //           date,
        //           timer: timer ? timer : null,
        //           imageUrl: fireBaseUrl,
        //           zone,
        //           imagePath: `/article_images/${imageName}`,
        //           affiliateLink: affiliateLink,
        //           news: timer === null ? false : true,
        //           authorIs: user.authorName ? user.authorName : "",
        //         };
        //         updateArticleFieldsWithImage(selectedCard.id, article).then(
        //           () => {
        //             // getFeaturedId.then((doc) => {
        //             //   setFeaturedId(doc.data().FeaturedId);
        //             // });
        //             //console.log("featuredId == selectedCard.id && !featuredId1",featuredId, selectedCard.id ,!featuredId,featuredId == selectedCard.id && !featuredId)
        //             //to set none from featured or breaking news
        //             if (
        //               featuredId == selectedCard.id &&
        //               !featured &&
        //               !breakingNews
        //             ) {
        //               addFeaturedId("", featured, breakingNews);
        //               setFeaturedId("");
        //             }
        //             //to set featured or breaking
        //             else if (featured || breakingNews) {
        //               if (
        //                 featuredId == selectedCard.id ||
        //                 (featuredId == "" && !none)
        //               ) {
        //                 addFeaturedId(selectedCard.id, featured, breakingNews);
        //               }
        //             }

        //             const temp = [...decks];
        //             const index = temp.findIndex(
        //               (el) => el.id === selectedCard.id
        //             );
        //             temp[index].title = title;
        //             temp[index].description = description;
        //             temp[index].description_editor = draftToHtml(
        //               convertToRaw(descriptionEditor.getCurrentContent())
        //             );
        //             temp[index].tags = updatedTags;
        //             temp[index].applyedFilters = applyedFilters;
        //             temp[index].date = date;
        //             temp[index].timer = timer ? timer : null;
        //             temp[index].imageUrl = fireBaseUrl;
        //             temp[index].imagePath = `/article_images/${imageName}`;
        //             temp[index].news = timer === null ? false : true;
        //             temp[index].affiliateLink = affiliateLink;
        //             temp[index].authorIs = user.authorName
        //               ? user.authorName
        //               : "";

        //             setDecks(temp);
        //             setLoading(false);
        //             message.info("Article Updated!");
        //           }
        //         );
        //       })
        //       .catch((err) => {
        //         console.log("ERR updateDeckNameImage", err.message);
        //       });
        //   }
        // );
      }
    } else {
      updateDeckWithoutImagesOrVideos(updatedTags);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    handleFireBaseUpload();
  };

  const addNewArticle = (imageName, videoName) => {
    const newArticle = {
      title: title,
      description: description,
      description_editor: draftToHtml(
        convertToRaw(descriptionEditor.getCurrentContent())
      ),
      tags: tags,
      date: date,
      zone: zone,
      // breakingNews:breakingNews,
      applyedFilters: applyedFilters,
      imagePath: `/article_images/${imageName}`,
      videoPath: `/article_videos/${videoName}`,
      imageUrl: imageUrl ? imageUrl : localStorage.getItem("uploadedImageUrl"),
      videoUrl: videoUrl ? videoUrl : localStorage.getItem("uploadedVideoUrl"),
      timer: timer === null ? null : timer,
      affiliateLink: affiliateLink,
      releaseNewsPrice: releaseNewsPrice,
      releaseDetailWhen: releaseDetailWhen,
      releaseDetailwhere:releaseDetailwhere, 
      releaseDetailPrice:releaseDetailPrice,
      news: timer === null ? false : true,
      createdAt: new Date(),
      authorIs: user.authorName ? user.authorName : "",
      descriptionImages: JSON.parse(
        localStorage.getItem("descriptionImagesUrl")
      ),
      isShowCommentSection,
      webViewCommentLink: isShowCommentSection ? webViewCommentLink : null,
      isNewSliderArticle,
      isBreakingNews
    };

    addArticle(newArticle).then((doc) => {
      if (!includes(featuredId, doc.id) && (featured || breakingNews)) {
        //for future use if needed
        addFeaturedId([...featuredId, doc.id], featured, breakingNews).then(() => {
          firebase
            .firestore()
            .collection("FeaturedStatus")
            .doc("FeaturedStatus")
            .get()
            .then((value) => {
              setFeaturedId([...featuredId, doc.id]);
            });
        });
      }
      const temp = [...decks];
      newArticle.id = doc.id;
      console.log("add article>>>", doc.id)
      console.log("add article>>>", doc.releaseDetailPrice)
      temp.push(newArticle);
      setDecks(temp);
      setLoading(false);
      resetFields();
      resetDescriptionImagesFromLocalStorage();
      message.info("Article Added!");
    });
  };

  const getChildByRefName = (childName, refName) => {
    return new Promise((resolutionFunc, rejectionFunc) => {
      storage()
        .ref(refName)
        .child(childName)
        .getDownloadURL()
        .then((fireBaseUrl) => {
          console.log(`================== fireBaseUrl ${refName}`, fireBaseUrl);
          if (refName === "article_images") {
            setImageUrl(fireBaseUrl);
            localStorage.setItem("uploadedImageUrl", fireBaseUrl);
            setImageAsFile(null);
          } else {
            setVideoUrl(fireBaseUrl);
            localStorage.setItem("uploadedVideoUrl", fireBaseUrl);
            setVideoAsFile(null);
          }
          resolutionFunc(true);
        })
        .catch((err) => {
          console.log("ERR getDownloadURL", err.message);
        });
    });
  };

  const imageUpload = (imageName, videoName) => {
    return new Promise((resolutionFunc, rejectionFunc) => {
      const uploadTask = storage()
        .ref(`/article_images/${imageName}`)
        .put(imageAsFile.originFileObj);
      uploadTask.on(
        "state_changed",
        (snapShot) => {
          console.log(snapShot);
        },
        (err) => {
          console.log("ERR uploadTask", err);
        },
        () => {
          getChildByRefName(imageName, "article_images").then(() => {
            !(imageAsFile && videoAsFile) &&
              addNewArticle(imageName, videoName);
            resolutionFunc(true);
          });
        }
      );
    });
  };

  const videoUpload = (imageName, videoName) => {
    return new Promise((resolutionFunc, rejectionFunc) => {
      const uploadTask = storage()
        .ref(`/article_videos/${videoName}`)
        .put(videoAsFile.originFileObj);
      uploadTask.on(
        "state_changed",
        (snapShot) => {
          console.log(snapShot);
        },
        (err) => {
          console.log("ERR uploadTask", err);
        },
        () => {
          getChildByRefName(videoName, "article_videos").then(() => {
            !(imageAsFile && videoAsFile) &&
              addNewArticle(imageName, videoName);
            resolutionFunc(true);
          });
        }
      );
    });
  };

  const handleFireBaseUpload = async () => {
    const imageName = uuidv4();
    const videoName = uuidv4();

    console.log("start of upload");
    if (imageAsFile === "") {
      return console.error(
        `not an image, the image file is a ${typeof imageAsFile}`
      );
    }

    setLoading(true);

    if (imageAsFile && videoAsFile) {
      imageUpload(imageName, videoName).then((res) => {
        videoUpload(imageName, videoName).then(() => {
          // if admin upload image and video both
          if (imageAsFile && videoAsFile) {
            addNewArticle(imageName, videoName);
          }
        });
      });
    } else if (imageAsFile) {
      imageUpload(imageName, videoName);
    } else if (videoAsFile) {
      videoUpload(imageName, videoName);
    } else {
      const newArticle = {
        title: title,
        description: description,
        description_editor: draftToHtml(
          convertToRaw(descriptionEditor.getCurrentContent())
        ),
        tags: tags,
        date: date,
        imageUrl: null,
        imagePath: null,
        // breakingNews:breakingNews,
        applyedFilters: applyedFilters,
        zone,
        timer: timer === null ? null : timer,
        affiliateLink: affiliateLink,
        releaseNewsPrice: releaseNewsPrice,
        releaseDetailWhen: releaseDetailWhen,
        releaseDetailwhere:releaseDetailwhere,
        releaseDetailPrice:releaseDetailPrice,
        news: timer === null ? false : true,
        createdAt: new Date(),
        authorIs: user.authorName ? user.authorName : "",
        descriptionImages: JSON.parse(
          localStorage.getItem("descriptionImagesUrl")
        ),
        isShowCommentSection,
        webViewCommentLink: isShowCommentSection ? webViewCommentLink : null,
        isNewSliderArticle,
        isBreakingNews
      };

      addArticle(newArticle).then((doc) => {
        // console.log("addArticle6777676>>", decks.find(item => featuredId == item.id), item.id, doc.id)
        if (featuredId.length < 2  && (featured || breakingNews)) {
          //for future use if needed
          // console.log("addArticlefdf>>", featuredId,breakingNews, featured)
          addFeaturedId([...featuredId, doc.id], featured, breakingNews).then(() => {
            firebase
              .firestore()
              .collection("FeaturedStatus")
              .doc("FeaturedStatus")
              .get()
              .then((value) => {
                console.log(value.data().featuredId)                
                setFeaturedId([...featuredId, doc.id]);
              });
          });
        }
        // console.log("addArticle>>", breakingNews, featured)
        // if (featured || breakingNews){
        //   addFeaturedId(doc.id, featured, breakingNews).then(()=>{
        //     firebase
        //     .firestore()
        //       .collection("FeaturedStatus")
        //       .doc("FeaturedStatus").get().then((value) => {
        //          setFeaturedId(value.data().FeaturedId);
        //     });
        //   });
        // }

        const temp = [...decks];
        newArticle.id = doc.id;
        temp.push(newArticle);
        setDecks(temp);
        setLoading(false);
        resetFields();
        resetDescriptionImagesFromLocalStorage();
        message.info("Article Added!");
      });
    }
  };

  const resetFields = () => {
    setTitle("");
    setDescription("");
    setDescriptionEditor("");
    setBreakingNews(false);
    setFeatured(false);
    setApplyedFilters([]);
    setTags("");
    setDate(null);
    setImageAsFile(null);
    setVideoAsFile(null);
    setTimer(null);
    setAffiliateLink("");
    setreleaseNewsPrice("");
    setreleaseDetailwhere("");
    setreleaseDetailWhen("");
    setreleaseDetailPrice("");
    setImageUrl("");
    setImagePath("");
    setImageName("");
    setVideoUrl("");
    setVideoPath("");
    setVideoName("");
    setIsShowCommentSection("");
    setisNewSliderArticle("")
    setWebViewCommentLink("");
    setisBreakingNews("");
    // set values from localStorage
    localStorage.setItem("uploadedImageUrl", "");
    localStorage.setItem("imagePath", "");
    localStorage.setItem("uploadedVideoUrl", "");
    localStorage.setItem("videoPath", "");
    resetDescriptionImagesFromLocalStorage();
  };

  const onFileUpload = (e) => {
    console.log(e.file);
    setImageAsFile(e.file);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const onVedioUpload = (e) => {
    console.log(e.file);
    setVideoAsFile(e.file);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const editDeck = (deck) => {
    let featuredUpdate = {};
    console.log("in edit deck>>", deck);
    // getFeaturedId.then((doc) => {
    //   // console.log("in edit deckFID>>", doc.data().FeaturedId);
    //   setFeaturedId(doc.data().FeaturedId);
    //   setBreakingNews(doc.data().news);
    //   setFeatured(doc.data().featured);

    //   featuredUpdate = {
    //     id: doc.data().FeaturedId,
    //     news: doc.data().news,
    //     featured: doc.data().featured,
    //   };
    // });

    const {
      title,
      description,
      tags,
      date,
      timer,
      description_editor,
      applyedFilters,
      breakingNews,
      id,
      imageUrl,
      videoUrl,
      videoPath,
      releaseDetailPrice,
      releaseDetailWhen,
      releaseDetailwhere,
      releaseNewsPrice,
      imagePath,
      descriptionImages,
      isShowCommentSection,
      isNewSliderArticle,
      isBreakingNews,
      webViewCommentLink
    } = deck;

    let editorState;
    // console.log("description_editor object",description_editor)
    if (description_editor == undefined) {
      // console.log("description_editor true",description_editor)
      editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML(description))
      );
    } else {
      // console.log("description_editor false",description_editor)
      const blocksFromHtml = htmlToDraft(description_editor);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      editorState = EditorState.createWithContent(contentState);
    }
    // console.log("edit passed data",deck)
    setSelectedCard(deck);
    setTitle(title);
    setreleaseDetailwhere(releaseDetailwhere);
    setreleaseDetailWhen(releaseDetailWhen);
    setreleaseDetailPrice(releaseDetailPrice);
    setreleaseNewsPrice(releaseNewsPrice);
    setDescription(description);
    setDescriptionEditor(editorState);
    setTags(tags.toString());
    setDate(date);
    console.log("============== featuredId" , featuredId, id)
    console.log("============== includes(featuredId, id)" , includes(featuredId, id))
    setFeatured(includes(featuredId, id));
    setApplyedFilters(applyedFilters);
    // setBreakingNews(breakingNews)
    // setBreakingNews(featuredUpdate.id == id && featuredUpdate.news);
    setTimer(timer);
    setEditMode(true);
    setImageUrl(imageUrl);
    setVideoUrl(videoUrl);
    setImagePath(imagePath);
    setVideoPath(videoPath);
    setIsShowCommentSection(isShowCommentSection || false);
    setisNewSliderArticle(isNewSliderArticle || false);
    setisBreakingNews(isBreakingNews || false);
    setWebViewCommentLink(webViewCommentLink || "");
    localStorage.setItem(
      "descriptionImagesUrl",
      JSON.stringify(descriptionImages)
    );
  };

  const cancelEditMode = () => {
    setEditMode(false);
    setSelectedCard(null);
    resetFields();
  };

  const handleOk = (e) => {
    console.log(e);
    setVisible(false);
  };

  const handleCancel = (e) => {
    console.log(e);
    setVisible(false);
  };

  const onDeleteDeck = async () => {
    confirm({
      title: "Are you sure delete this deck?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        if (selectedCard.imagePath) {
          deleteFileFromStorage(selectedCard.imagePath).then(() => {
            deleteDeck(selectedCard.id).then(() => {
              if (includes(featuredId, selectedCard.id)) {
                addFeaturedId(filter(featuredId, fID => fID !== selectedCard.id), false, false);
                setFeaturedId(filter(featuredId, fID => fID !== selectedCard.id));
              }
              setEditMode(false);
              const temp = [...decks];
              const index = temp.findIndex((el) => el.id === selectedCard.id);
              temp.splice(index, 1);
              setDecks(temp);
              setSelectedCard(null);
              resetFields();
              message.success("Deck Deleted!");
              setLoading(false);
            });
          });
        } else {
          deleteDeck(selectedCard.id).then(() => {
            if (includes(featuredId, selectedCard.id)) {
              addFeaturedId(filter(featuredId, fID => fID !== selectedCard.id), false, false);
              setFeaturedId(filter(featuredId, fID => fID !== selectedCard.id));
            }
            // console.log("delete?>>>>", featured, breakingNews);
            setEditMode(false);
            const temp = [...decks];
            const index = temp.findIndex((el) => el.id === selectedCard.id);
            temp.splice(index, 1);
            setDecks(temp);
            setSelectedCard(null);
            resetFields();
            message.success("Deck Deleted!");
            setLoading(false);
          });
        }
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const logout = () => {
    firebase
      .auth()
      .signOut()
      .then(function () {
        // Sign-out successful.
        localStorage.clear();
        setLoggedIn(false);
      })
      .catch(function (error) {
        // An error happened.
        console.error(error);
      });
  };

  const toggleLiveStream = (checked) => {
    setStreamLoading(true);
    setLiveStream(checked, liveStreamUrl, liveStreamTitle)
      .then(() => {
        setIsLiveStream(checked);
        setStreamLoading(false);
      })
      .catch((err) => console.log("ERR setLiveStream:", err.message));
  };

  const onChange = (value, key) => {
    switch (key) {
      case "title":
        setTitle(value);
        break;
      case "description":
        setDescription(value);
        break;
      case "description_editor":
        setDescriptionEditor(value);
        // console.log("descEditor>>>>>", value)
        break;
      case "affiliate":
        setAffiliateLink(value);
        break;
      case "priceVal":
        setreleaseNewsPrice(value);
        break;
      case "detailWhereVal":
        setreleaseDetailwhere(value);
        break;
      case "detailWhenVal":
        setreleaseDetailWhen(value);
        break;
      case "detailPriceVal":
        setreleaseDetailPrice(value);
        break;
      case "none":
        setFeatured(false);
        setBreakingNews(false);
        setNoneStatus(value);
        break;
      case "featured":
        setFeatured(value);
        setNoneStatus(false);
        break;
      case "breakingNews":
        setBreakingNews(value);
        setNoneStatus(false);
        break;
      case "applyedFilters":
        // console.log("applyedFilters Values>>>", value)
        setApplyedFilters(value);
        break;
      case "tags":
        setTags(value.split(","));
        break;
      case "date":
        setDate(value);
        break;
      case "timer":
        if (value) {
          const dateString = +moment(value).tz(zone);

          // console.log(moment(dateString));
          // value = moment(dateString)
          value = dateString;
        }
        // console.log('after',value)
        setTimer(value);
        break;
      case "zone":
        setZone(value);
        break;
      case "webViewCommentLink":
        setWebViewCommentLink(value);
        break;
      default:
        break;
    }
  };

  const addArticleSlider = (imageAsFile) => {
    const imageName = uuidv4();
    // console.log("start of upload");
    if (imageAsFile === "") {
      return console.error(
        `not an image, the image file is a ${typeof imageAsFile}`
      );
    }
    setLoading(true);
    const uploadTask = storage()
      .ref(`/slider_images/${imageName}`)
      .put(imageAsFile);
    uploadTask.on(
      "state_changed",
      (snapShot) => {
        console.log(snapShot);
      },
      (err) => {
        console.log("ERR uploadTask", err);
      },
      () => {
        storage()
          .ref("slider_images")
          .child(imageName)
          .getDownloadURL()
          .then((fireBaseUrl) => {
            const temp = [...articleSliders];
            temp.push({
              imagePath: `/slider_images/${imageName}`,
              imageUrl: fireBaseUrl,
            });
            updateArticleSliders(temp)
              .then(() => {
                setArticleSliders(temp);
                setLoading(false);
              })
              .catch((err) =>
                console.log("ERR updateArticleSliders:", err.message)
              );
          })
          .catch((err) => console.log("ERR getDownloadURL", err.message));
      }
    );
  };

  const removeArticleSlider = (sliderIndex) => {
    const temp = [...articleSliders];
    setLoading(true);
    deleteFileFromStorage(temp[sliderIndex].imagePath)
      .then(() => {
        temp.splice(sliderIndex, 1);
        updateArticleSliders(temp)
          .then(() => {
            setArticleSliders(temp);
            setLoading(false);
          })
          .catch((err) => {
            console.log("ERR updateArticleSliders", err.message);
          });
      })
      .catch((err) => console.log("ERR deleteFileFromStorage", err.message));
  };

  const addNewsSlider = (file) => {
    const imageName = uuidv4();
    // console.log("start of upload");
    if (file === "") {
      return console.error(`not an image, the image file is a ${typeof file}`);
    }
    setLoading(true);
    const uploadTask = storage().ref(`/slider_images/${imageName}`).put(file);
    uploadTask.on(
      "state_changed",
      (snapShot) => {
        console.log(snapShot);
      },
      (err) => {
        console.log("ERR uploadTask", err);
      },
      () => {
        storage()
          .ref("slider_images")
          .child(imageName)
          .getDownloadURL()
          .then((fireBaseUrl) => {
            const temp = [...newsSliders];
            temp.push({
              imagePath: `/slider_images/${imageName}`,
              imageUrl: fireBaseUrl,
            });
            updateNewsSliders(temp)
              .then(() => {
                setNewsSliders(temp);
                console.log(temp);
                setLoading(false);
              })
              .catch((err) =>
                console.log("ERR updateArticleSliders:", err.message)
              );
          })
          .catch((err) => console.log("ERR getDownloadURL", err.message));
      }
    );
  };

  const removeNewsSlider = (sliderIndex) => {
    const temp = [...newsSliders];
    setLoading(true);
    deleteFileFromStorage(temp[sliderIndex].imagePath)
      .then(() => {
        temp.splice(sliderIndex, 1);
        updateNewsSliders(temp)
          .then(() => {
            setNewsSliders(temp);
            setLoading(false);
          })
          .catch((err) => {
            console.log("ERR updateNewsSliders", err.message);
          });
      })
      .catch((err) => console.log("ERR deleteFileFromStorage", err.message));
  };

  const _addAuthor = () => {
    if (authorName === "") return alert("Enter Author Name");
    if (authorPassword === "") return alert("Enter Author Password");
    if (!validateEmail(authorEmail)) return alert("Enter a valid Email");

    const index = authors.findIndex(
      (el) => el.authorEmail.toUpperCase() === authorEmail.toUpperCase()
    );
    // Check if author exists
    if (index !== -1) {
      return alert("Author with email already exists");
    }

    setLoading(true);
    signupUser(authorEmail, authorPassword).then(({ uid }) => {
      const author = {
        authorName: authorName,
        authorEmail: authorEmail,
        authorPassword: authorPassword,
        isAdmin: false,
        id: uid,
      };

      addAuthor(uid, author).then(() => {
        const temp = [...authors];
        temp.push(author);
        setAuthors(temp);
        setLoading(false);
      });
    });
  };

  const _deleteAuthor = (authorID) => {
    confirm({
      title: "Are you sure delete this deck?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        console.log("authorID>>>>", authorID);
        deleteAuthor(authorID)
          .then(() => {
            const temp = [...authors];
            const index = temp.findIndex((el) => el.id === authorID);
            temp.splice(index, 1);
            setAuthors(temp);
            setLoading(false);
          })
          .catch((err) => console.log("ERR deleteAuthor", err.message));
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const sendPushNotification = () => {
    if (notificationTitle === "")
      return alert("Please Enter Notification Title ");
    if (notificationMessage === "")
      return alert("Please Enter Notification Message ");
    setTokenLoading(true);
    console.log(tokens);
    axios
      .post("https://beastnews-notfication.herokuapp.com/notification", {
        title: notificationTitle,
        message: notificationMessage,
        tokens: tokens,
      })
      .then(function (response) {
        console.log(response);
        if (response.data.success) message.info("Notification Sent!");
        setTokenLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };


  const showComments = (record) => {
    const blogComments = record.comments || [];
    setComments(record.comments || []);
    console.log(record.id);
    setSelectedArticle(record.id);
    setToogleCoomentModal(!toogleCoomentModal);
  };

  const deleteComment = (comment) => {
    const commentData = comments || [];
    const updatedComments = commentData.map((com) => {
      if (com.time === comment.time) {
        com.delete = true;
      }
      if (com.levelcomments) {
        const inner = com.levelcomments.map((innerComment) => {
          if (innerComment.time === comment.time) {
            innerComment.delete = true;
          }
          return innerComment;
        });
        com.levelcomments = inner;
      }
      return com;
    });
    deleteCommentRecord(selectedArticle, updatedComments);
    setComments(updatedComments);
  };

  const getCommentsData = () => {
    return comments.map((com, idx) => {
      if (com.levelcomments) {
        return (
          <CommentsTable
            comment={com}
            key={com.time}
            deleteComment={deleteComment}
          >
            {com.levelcomments.map((innerComment, idx) => {
              return (
                <CommentsTable
                  comment={innerComment}
                  key={innerComment.time}
                  deleteComment={deleteComment}
                />
              );
            })}
          </CommentsTable>
        );
      } else {
        return (
          <CommentsTable
            comment={com}
            key={com.time}
            deleteComment={deleteComment}
          />
        );
      }
    });
  };

  if (loggedIn === null) return <div />;
  if (loggedIn === false) return <Redirect to={"/"} />;
  console.log("==================  featuredId ========>>>>>>>>", featuredId);
  return (
    <Layout className="layout" style={{ background: "#1f2228" }}>
      <Header logout={logout} componentName="Dashboard" />
      <Content style={{ padding: "0 10px", background: "#1f2228" }}>
        <div className="site-layout-content">
          <Row>
            <Col span={14}>
              <Card style={{ borderRadius: "15px" }}>
                <DeckForm
                  featuredId={featuredId}
                  editMode={editMode}
                  onSubmit={editMode ? updateDeck : onSubmit}
                  onFileUpload={onFileUpload}
                  onVedioUpload={onVedioUpload}
                  onChange={onChange}
                  file={imageAsFile}
                  videoFile={videoAsFile}
                  title={title}
                  description={description}
                  description_editor={descriptionEditor}
                  tags={tags}
                  date={date}
                  timer={timer}
                  zone={zone}
                  id={editMode ? selectedCard.id : ""}
                  featured={featured}
                  none={none}
                  breakingNews={breakingNews}
                  applyedFilters={applyedFilters}
                  // breakingNews={breakingNews}
                  loading={loading}
                  decks={decks}
                  onCancelEditMode={cancelEditMode}
                  onDeletePress={onDeleteDeck}
                  setIsShowCommentSection={setIsShowCommentSection}
                  isShowCommentSection={isShowCommentSection}
                  webViewCommentLink={webViewCommentLink}
                  setisNewSliderArticle={setisNewSliderArticle}
                  isNewSliderArticle={isNewSliderArticle}
                  setisBreakingNews={setisBreakingNews}
                  isBreakingNews={isBreakingNews}
                />
              </Card>
            </Col>
            {/* {user.isAdmin && ( */}
            <Col span={10}>
              <LiveStream
                loading={loading}
                newsSliders={newsSliders}
                isLiveStream={isLiveStream}
                tokenLoading={tokenLoading}
                articleSliders={articleSliders}
                streamLoading={streamLoading}
                liveStreamUrl={liveStreamUrl}
                liveStreamTitle={liveStreamTitle}
                notificationTitle={notificationTitle}
                notificationMessage={notificationMessage}
                setLiveStreamUrl={setLiveStreamUrl}
                setliveStreamTitle={setliveStreamTitle}
                toggleLiveStream={toggleLiveStream}
                setNotificationTitle={setNotificationTitle}
                setNotificationMessage={setNotificationMessage}
                sendPushNotification={sendPushNotification}
                removeArticleSlider={removeArticleSlider}
                addArticleSlider={addArticleSlider}
                removeNewsSlider={removeNewsSlider}
                addNewsSlider={addNewsSlider}
              />
            </Col>
            {/* )} */}
          </Row>
          <Row>
            <Col flex={2}>
              <Card style={{ marginTop: 10, borderRadius: "15px" }}>
                <DeckTable
                  featuredId={featuredId}
                  decks={decks}
                  onEditClick={editDeck}
                  showComments={showComments}
                  comments={comments}
                />
              </Card>
            </Col>
          </Row>
        </div>
      </Content>
      <Footer
        loading={loading}
        authorName={authorName}
        authorEmail={authorEmail}
        authorPassword={authorPassword}
        setAuthorName={setAuthorName}
        setAuthorEmail={setAuthorEmail}
        setAuthorPassword={setAuthorPassword}
        authors={authors}
        _deleteAuthor={_deleteAuthor}
        _addAuthor={_addAuthor}
      />
      <Modal
        title="Are you sure to delete this item"
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
      />
      <Modal
        title="Comments"
        className="comments-modal"
        visible={toogleCoomentModal}
        onOk={showComments}
        onCancel={showComments}
      >
        {" "}
        {getCommentsData()}
      </Modal>
    </Layout>
  );
}

const validateEmail = (email) => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};
